import BrainFaqAPI from 'dashboard/api/brain/faq';
import { createStore } from '../storeFactory';

const SET_PENDING_COUNT = 'SET_PENDING_COUNT';

export default createStore({
  name: 'BrainFaq',
  API: BrainFaqAPI,
  getters: {
    getPendingCount: state => state.meta.pendingCount || 0,
  },
  mutations: {
    [SET_PENDING_COUNT](state, count) {
      state.meta = { ...state.meta, pendingCount: Number(count) };
    },
  },
  actions: mutations => ({
    removeBulkFaqs: ({ commit, state }, ids) => {
      const updated = state.records.filter(r => !ids.includes(r.id));
      commit(mutations.SET, updated);
    },
    // Override default delete: API.delete handles {id, assistantId} payload but
    // the shared storeFactory mutation expects a scalar id (record.id !== id).
    // Without this override the local store stays stale until the next refetch
    // and bulk-delete callers' "is this page now empty?" checks return false
    // even after the records were deleted server-side.
    delete: async ({ commit }, payload) => {
      const id = payload?.id ?? payload;
      commit(mutations.SET_UI_FLAG, { deletingItem: true });
      try {
        await BrainFaqAPI.delete(payload);
        commit(mutations.DELETE, id);
        return id;
      } finally {
        commit(mutations.SET_UI_FLAG, { deletingItem: false });
      }
    },
    approve: async ({ commit }, { id, assistantId }) => {
      commit(mutations.SET_UI_FLAG, { updatingItem: true });
      try {
        const response = await BrainFaqAPI.approve({ id, assistantId });
        commit(mutations.EDIT, response.data);
        return response.data;
      } finally {
        commit(mutations.SET_UI_FLAG, { updatingItem: false });
      }
    },
    reject: async ({ commit }, { id, assistantId }) => {
      commit(mutations.SET_UI_FLAG, { updatingItem: true });
      try {
        const response = await BrainFaqAPI.reject({ id, assistantId });
        commit(mutations.EDIT, response.data);
        return response.data;
      } finally {
        commit(mutations.SET_UI_FLAG, { updatingItem: false });
      }
    },
    bulkApprove: async (_, { ids, assistantId }) => {
      const response = await BrainFaqAPI.bulkActions({
        ids,
        action: 'approve',
        assistantId,
      });
      // Return { succeeded, failed } so callers can detect 207 partial-failure.
      return response.data;
    },
    fetchPendingCount: async ({ commit }, assistantId) => {
      try {
        const response = await BrainFaqAPI.get({
          status: 'pending',
          page: 1,
          assistantId,
        });
        const count = response.data?.meta?.total_count || 0;
        commit(SET_PENDING_COUNT, count);
      } catch (error) {
        commit(SET_PENDING_COUNT, 0);
      }
    },
  }),
});
